import React from 'react'
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";
const NumberFormatCustom = React.forwardRef((props,ref) =>  {
  const { inputRef, onChange,limit, ...other } = props;

  return (
    <NumberFormat
      {...other}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix=""
      isAllowed={values => {
        if(!limit) return true;
        const { formattedValue, floatValue } = values
        if (floatValue == null) {
            return formattedValue === ''
        } else {
            return (floatValue <= 100 && floatValue >= 0)
        }
    }}
    />
  );
})

NumberFormatCustom.propTypes = {
  // inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default NumberFormatCustom;